//@ts-ignore
import { Card, Modal } from "react-bootstrap";
import 
React, 
{ 
  //useContext, 
  useState 
} from "react";
//@ts-ignore
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
// import { ContextUser } from "../../../../context/ContextUser";

interface Props {
  coid: string;
  itemid: string;
  color: string;
  size: string;
  customer: string;
  orderid: string;
  fourxthree: boolean;
  title: string;
  refButton: (ref: HTMLButtonElement | null) => void;
}

export function PrintItem(props: Props) {
  let componentRef: any;
  // const context = useContext(ContextUser);
  const [show, setShow] = useState(false);

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header
          closeButton
          translate="yes"
          onAuxClick={() => {}}
          onAuxClickCapture={() => {}}
        >
          <Modal.Title>Print Item</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Card
            style={{
              borderStyle: "solid",
              borderWidth: 1,
              width: props.fourxthree ? "10cm" : "105mm",
              height: props.fourxthree ? "3cm" : "105mm",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
            }}
            ref={(ref: any) => (componentRef = ref)}
          >
            <Card.Body
              className="text-center"
              style={{
                fontSize: props.fourxthree ? 9 : 20,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {!props.fourxthree && (
                <>
                  <div>L192 ITEM</div>
                  {/* <div>
                    {context.merchant.name} | {props.itemid}
                  </div> */}
                </>
              )}
              <Barcode
                value={props.coid}
                format={"CODE128"}
                width={2}
                // height={props.fourxthree ? 60 : 50}
                // width={props.fourxthree ? 1 : 2}
                // fontSize={props.fourxthree ? 10 : 20}
              />
              {!props.fourxthree && (
                <>
                  <br />
                  <div>
                    <span>C{props.customer}</span>
                    {/* <span>O{props.orderid}</span> */}
                  </div>
                  <br/>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: 'left', borderWidth: '0 1px 0 0', borderStyle: 'solid' }}>{props.color ? props.color.toUpperCase() : ""}</td>
                        <td style={{ textAlign: 'right' }}>{props.size ? props.size.toUpperCase() : ""}</td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div>
                    <span>{props.color ? props.color.toUpperCase() : ""}</span>{" "}
                    | <span>{props.size ? props.size.toUpperCase() : ""}</span>
                  </div> */}
                </>
              )}
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <ReactToPrint
            trigger={() => <button className="btn btn-primary">Print</button>}
            content={() => componentRef}
          />
        </Modal.Footer>
      </Modal>
      <button
        onClick={() => setShow(true)}
        ref={props.refButton}
        style={{ display: "none" }}
      >
        {props.title}
      </button>
    </>
  );
}
